import React from "react";

import {
  Drawer,
  // DrawerClose,
  DrawerContent,
  // DrawerDescription,
  // DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  DrawerClose,
} from "./index";
import { useTranslation } from "react-i18next";
import images from "../../../images";
import privacyPolicySections from "../../../contanst/privacyPolicySections.json";

const DataProtectionPolicyModal = ({
  isOpen,
  onOpenChange,
  onAgree,
  onClose,
}) => {
  const { t } = useTranslation();

  // const renderWithBold = (text) => {
  //   const parts = text.split(/(\*\*[^*]+\*\*)|(\n)/g);

  //   return parts.map((part, idx) => {
  //     if (!part) return null;
  //     if (part === "\n") return <br key={idx} />;
  //     if (part.startsWith("**") && part.endsWith("**")) {
  //       return <strong key={idx}>{part.slice(2, -2)}</strong>;
  //     }
  //     return <span key={idx}>{part}</span>;
  //   });
  // };

  return (
    <>
      <Drawer open={isOpen} onOpenChange={onOpenChange}>
        <DrawerTrigger className="underline block">
          <span>{t("signUp.dataProtectionPolicy")}</span>
        </DrawerTrigger>
        <DrawerContent className="fixed inset-0 z-50 bg-white  flex flex-col p-4 max-h-screen">
          <DrawerHeader>
            <DrawerTitle className="flex justify-start mt-6">
              <span className="text-2xl font-bold text-[#333333]">
                {t("policy.title")}
              </span>
            </DrawerTitle>
            {/* <DrawerDescription>{t("policy.description")}</DrawerDescription> */}
            <DrawerClose className="absolute top-[40px] right-4">
              {/* <button
                className="text-2xl w-6 h-6 font-bold text-gray-700 hover:text-gray-900"
                aria-label="Close"
              >
                &times;
              </button> */}
              <img src={images.CloseModalIconGray} className="w-6 h-6" alt="" />
            </DrawerClose>
          </DrawerHeader>
          <div className="flex-1 px-4 py-1 overflow-y-auto">
            {/* {[...Array(10)].map((_, i) => {
              const key = (i + 1).toString();
              return (
                <div key={key} className="mb-4">
                  <h4 className="font-bold mb-1">
                    {`${key}. ${t(`policy.sections.${key}.title`)}`}
                  </h4>
                  <p className="whitespace-pre-wrap text-sm text-gray-700">
                    {renderWithBold(t(`policy.sections.${key}.content`))}
                  </p>
                </div>
              );
            })} */}
            {privacyPolicySections.map((item, index) => (
              <div key={index} className="mb-4">
                <h3 className={"text-[#333333] text-sm font-bold"}>
                  {index + 1}. {item.title}
                </h3>
                <div className="pl-[13px]">
                  <span className="text-[#333333] text-sm font-normal leading-none">
                    {item.content}
                  </span>
                </div>
              </div>
            ))}
            {/* <Button
              className="px-4 py-3 text-base font-medium text-white bg-[#253FF6] rounded-xl w-full"
              text={t("policy.agree")}
              onClick={() => {
                onAgree();
                onClose();
              }}
            />
            <button
              className="px-4 py-3 text-base font-medium text-[#253FF6] bg-white border border-[#253FF6] rounded-xl w-full"
              onClick={onClose}
            >
              {t("policy.cancel")}
            </button> */}
          </div>

          {/* <DrawerFooter className="p-4 border-t border-gray-200">
            <Button
              className="px-4 py-3 text-base font-medium text-white bg-[#253FF6] rounded-xl w-full"
              text={t("policy.agree")}
              onClick={() => {
                onAgree();
                onClose();
              }}
            />
            <button
              className="px-4 py-3 text-base font-medium text-[#253FF6] bg-white border border-[#253FF6] rounded-xl w-full"
              onClick={onClose}
            >
              {t("policy.cancel")}
            </button>
          </DrawerFooter> */}
        </DrawerContent>
      </Drawer>
    </>
  );
};
export default DataProtectionPolicyModal;
